import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getMeQueryOptions } from '../../auth/services/useMeQuery'
import { intentionApi } from '../api/intentionApi'
import type { TDeleteIntentionPayload } from '../api/types/deleteIntentionApi.types'

export const useDeleteIntentionMutation = (intentionId?: number, payload?: TDeleteIntentionPayload) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => intentionApi.deleteIntention(intentionId, payload),
    onSuccess: () => {
      queryClient.setQueryData(getMeQueryOptions().queryKey, (data) => data && { ...data, intention: undefined })
    },
  })
}
